import React from "react";

const Quote = (props) => {

    const blok = props.blok;

    return (
        <section className="width">

            <figure className="flex space-y-4 lg:space-y-8 flex-col">
                
                <div className="font-serif text-2xl lg:text-53 flex font-extralight">
                    <span>{`"`}</span>
                <blockquote dangerouslySetInnerHTML={{ __html: blok.quote + ` "` }}>

                </blockquote>

                </div>
                <figcaption className="font-medium ml-auto lg:pr-16 text-sm lg:text-lg text-right lg:text-left">{blok.author}</figcaption>

            </figure>

        </section>
    )
}

export default Quote;